// This file patches the global environment to make xlsx work properly
import { Buffer } from 'buffer';

// Ensure Buffer is available globally
window.Buffer = window.Buffer || Buffer;

// Create a simple process object with the necessary properties
const process = {
  env: {},
  browser: true,
  nextTick: function(fn) {
    setTimeout(fn, 0);
  },
  title: 'browser',
  version: '',
  versions: {},
  
  // Additional properties that xlsx might need
  cwd: function() { return '/' },
  platform: 'browser',
  arch: 'browser',
  
  // Add a binding property with a module property
  binding: function(name) {
    if (name === 'constants') {
      return {
        NODE_PERFORMANCE_MILESTONE_TIME_ORIGIN: 0,
        NODE_PERFORMANCE_MILESTONE_NODE_START: 1
      };
    }
    return {};
  }
};

// Add the module property to process
process.module = true;

// Ensure process is available globally
window.process = window.process || process; 